export const chatbotPalette = {
  teal: "#70EFD2",
  tealDeep: "#2B87C4",
  tealSoft: "#AEE9DC",
  mint: "#EAF7FF",
  ink: "#0E1D34",
  inkSoft: "#162B4A",
  panelTop: "rgba(10, 26, 48, 0.98)",
  panelBottom: "rgba(10, 20, 36, 0.98)",
  userBubble: "rgba(255,255,255,0.08)",
  border: "rgba(104, 207, 228, 0.30)",
  borderSoft: "rgba(203, 239, 255, 0.24)",
  textMain: "#F2FAFF",
  textMuted: "#C4D7E3",
  danger: "#FFB4B4",
  success: "#A4E9FF",
  softGlass: "rgba(255,255,255,0.06)",
};

export const chatbotGradients = {
  panel: `linear-gradient(180deg, rgba(10, 25, 45, 0.95) 0%, rgba(9, 18, 33, 0.98) 100%)`,
  panelOverlay:
    "radial-gradient(circle at top left, rgba(104, 207, 228, 0.18) 0%, rgba(104, 207, 228, 0.07) 24%, transparent 52%), radial-gradient(circle at bottom right, rgba(43, 135, 196, 0.16) 0%, transparent 40%)",
  header: "linear-gradient(135deg, rgba(117, 204, 224, 0.98) 0%, rgba(76, 173, 208, 0.98) 100%)",
  launcher: "radial-gradient(circle at 30% 30%, rgba(237, 250, 255, 1) 0%, rgba(169, 223, 244, 1) 32%, rgba(74, 156, 213, 1) 100%)",
  launcherHover: "radial-gradient(circle at 30% 30%, rgba(245, 253, 255, 1) 0%, rgba(189, 231, 248, 1) 34%, rgba(82, 170, 224, 1) 100%)",
  assistantBubble: "linear-gradient(180deg, #38576D 0%, #304C62 100%)",
  userBubble: "linear-gradient(135deg, #D3F2E9 0%, #B4E4D9 100%)",
  sendButton: "linear-gradient(135deg, #9af1dc 0%, #70dfc4 100%)",
};